export const menuItems = [
  {
    path: "/",
    text: "home",
  },
  {
    path: "/custom-websites",
    text: "custom websites",
  },
  {
    path: "/contact",
    text: "contact",
  },
]
